import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'zh-Hans',
  months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
  monthsShort: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
  weekdays: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
  weekdaysMin: ['日', '一', '二', '三', '四', '五', '六'],
  weekdaysShort: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'Ah:mm',
    lts: 'Ah:mm:ss',
    L: 'YYYY/M/D',
    LL: 'YYYY年M月D日',
    'LL-D': 'YYYY年M月',
    'LL-Y': 'M月D日',
    LLL: 'YYYY年M月D日 HH:mm',
    'LLL-Y': 'M月D日 HH:mm',
    LLLL: 'YYYY年M月D日 dddd HH:mm',
    'LLLL-Y': 'M月D日 dddd HH:mm',
    l: 'YYYY/M/D',
    'l-Y': 'M/D',
    ll: 'YYYY年M月D日',
    'll-Y': 'M月D日',
    'll-D': 'YYYY年M月',
    lll: 'YYYY年M月D日 H:mm',
    'lll-Y': 'M月D日 H:mm',
    llll: 'YYYY年M月D日 ddd H:mm',
    'llll-Y': 'M月D日 ddd H:mm',
    'll-Y+w': 'M月D日 ddd',
    'LT+to': 'HH:mm（[GMT]Z）',
    'LLL+to': 'YYYY年M月D日 HH:mm（[GMT]Z）',
  },
  meridiem: { am: '上午', pm: '下午', AM: '上午', PM: '下午' },
  past: {
    y: { other: '%s年前' },
    M: { other: '%s个月前' },
    w: { other: '%s周前' },
    d: { other: '%s天前' },
    h: { other: '%s小时前' },
    m: { other: '%s分钟前' },
    s: { other: '%s秒前' },
  },
  future: {
    y: { other: '%s年后' },
    M: { other: '%s个月后' },
    w: { other: '%s周后' },
    d: { other: '%s天后' },
    h: { other: '%s小时后' },
    m: { other: '%s分钟后' },
    s: { other: '%s秒后' },
  },
  pastLong: {
    y: { other: '%s年前' },
    M: { other: '%s个月前' },
    w: { other: '%s周前' },
    d: { other: '%s天前' },
    h: { other: '%s小时前' },
    m: { other: '%s分钟前' },
    s: { other: '%s秒钟前' },
  },
  futureLong: {
    y: { other: '%s年后' },
    M: { other: '%s个月后' },
    w: { other: '%s周后' },
    d: { other: '%s天后' },
    h: { other: '%s小时后' },
    m: { other: '%s分钟后' },
    s: { other: '%s秒钟后' },
  },
  abbr: {
    y: { other: '%s年' },
    M: { other: '%s月' },
    w: { other: '%s周' },
    d: { other: '%s天' },
    h: { other: '%s小时' },
    m: { other: '%s分钟' },
    s: { other: '%s秒' },
  },
  full: {
    y: { other: '%s年' },
    M: { other: '%s个月' },
    w: { other: '%s周' },
    d: { other: '%s天' },
    h: { other: '%s小时' },
    m: { other: '%s分钟' },
    s: { other: '%s秒钟' },
  },
  justNow: '刚刚',
  yesterday: '昨天',
  today: '今天',
  tomorrow: '明天',
  weekStart: 1,
  timeRange: '%$1s – %$2s',
  timeZone: '%$2s%$1s',
  timePref: { 'HH:mm': 'Ah:mm', 'H:mm': 'Ah:mm' },
  timeRangeStyles: {
    yl: { start: 'YYYY年M月D日', end: 'YYYY年M月D日' },
    'yl-1': { start: 'M月D日', end: 'YYYY年M月D日' },
    ml: { start: 'M月D日', end: 'M月D日' },
    'ml-1': { start: 'YYYY年M月D日', end: 'D日' },
    dl: { start: 'M月D日', end: 'D日' },
    y: { start: 'YYYY年M月D日', end: 'YYYY年M月D日' },
    'y-1': { start: 'YYYY年M月D日', end: 'M月D日' },
    m: { start: 'M月D日', end: 'M月D日' },
    'm-1': { start: 'YYYY年M月D日', end: 'D日' },
    d: { start: 'M月D日', end: 'D日' },
    Y: { start: 'YYYY年M月D日ddd', end: 'YYYY年M月D日ddd' },
    'Y-1': { start: 'YYYY年M月D日ddd', end: 'M月D日ddd' },
    M: { start: 'M月D日ddd', end: 'M月D日ddd' },
    D: { start: 'M月D日ddd', end: 'M月D日ddd' },
    yt: { start: 'YYYY年M月D日 HH:mm', end: 'YYYY年M月D日 HH:mm' },
    mt: { start: 'M月D日 HH:mm', end: 'M月D日 HH:mm' },
    dt: { start: 'M月D日 HH:mm', end: 'M月D日 HH:mm' },
    t: { start: 'HH:mm', end: 'HH:mm' },
    'yt+to': { start: 'YYYY年M月D日 HH:mm', end: 'YYYY年M月D日 HH:mm（[GMT]Z）' },
    'mt+to': { start: 'M月D日 HH:mm', end: 'M月D日 HH:mm（[GMT]Z）' },
    'dt+to': { start: 'M月D日 HH:mm', end: 'M月D日 HH:mm（[GMT]Z）' },
    't+to': { start: 'HH:mm', end: 'HH:mm（[GMT]Z）' },
  },
};
const localeName: LocaleName = 'zh-Hans';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (number, period) => {
    switch (period) {
      case 'W':
        return `${number}周`;
      default:
        return `${number}日`;
    }
  },
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? '上午' : '上午';
    } else {
      return isLowerCase ? '下午' : '下午';
    }
  },
};
